import request from '../utils/request';
import { resolveNetworkType } from '../utils/network';

/** 查询数据列表（平铺，单条记录） */
export function fetchDataList(params = {}) {
  return request.get('/data', { params });
}

/** 查询数据分组列表（按 object_name 分组，group 含汇总 + files）；silent=后台轮询，失败不打扰用户 */
export function fetchDataGroups(params = {}, options = {}) {
  return request.get('/data/groups', { params, ...options });
}

export function fetchDataDetail(id) {
  return request.get(`/data/${id}`);
}

/** 获取下载链接：direct 返回对象公开直连 URL（不预签名）；文件夹返回当前网络通道的打包直链 */
export async function fetchDownloadUrl(objectName, filePath, options = {}) {
  const baseParams = { object_name: objectName };
  if (filePath) baseParams.file_path = filePath;
  if (options.direct) baseParams.direct = 1;

  // 显式 internal 参数优先；否则按顶栏所选网络通道
  const useInternal = typeof options.internal === 'boolean'
    ? options.internal
    : resolveNetworkType() === 'internal';

  const params = { ...baseParams, network_type: useInternal ? 'internal' : 'external' };
  return request.get('/data/download-url', { params });
}

/** 获取文件夹下载清单（预签名 URL；浏览器直连 MinIO，字节不经后端） */
export function fetchDownloadManifest(objectName, options = {}) {
  return request.get('/data/download-manifest', {
    params: { object_name: objectName },
    ...options,
  });
}

/** 获取 Node Studio 可视化一次性票据 */
export function fetchOpenTicket(id) {
  return request.post(`/data/${id}/open-ticket`);
}

/** 兑换可视化票据 → 预签名 URL（票据一次性，URL 30 分钟有效） */
export async function fetchStreamUrl(ticket, networkType) {
  const params = { ticket };
  if (networkType) params.network_type = networkType;
  return request.get('/data/stream-url', { params });
}

/** 获取文件夹级可视化票据（一次性，含文件夹内全部 .pb） */
export function fetchFolderTicket(objectName) {
  return request.post('/data/folder-ticket', { object_name: objectName });
}

/** 获取文件夹级远程播放会话（Lichtblick 深链；清单存 Redis 30 分钟，可重复读） */
export function fetchFolderSession(objectName) {
  return request.post('/data/folder-session', { object_name: objectName });
}

/** 获取 Node Studio 下载信息（探测端口 + 下载地址） */
export function fetchNodeStudioDownloadInfo() {
  return request.get('/node-studio/download-info');
}

/** 获取 Lichtblick 可视化入口配置（静态站地址 + 布局文件地址） */
export function fetchLichtblickVisualizeConfig() {
  return request.get('/lichtblick/visualize-config');
}

/** 获取 MinIO 预签名上传 URL（浏览器直传，不经后端） */
export function fetchUploadUrl(objectName, fileName, options = {}) {
  const useInternal = typeof options.internal === 'boolean'
    ? options.internal
    : resolveNetworkType() === 'internal';
  return request.post('/data/upload-url', {
    object_name: objectName,
    file_name: fileName,
    network_type: useInternal ? 'internal' : 'external',
  });
}

/** 批量删除 MinIO 对象（取消上传时回滚清理） */
export function deleteObjects(objects) {
  return request.post('/data/delete-objects', { objects });
}

/** 批量创建 data 表记录（上传完成后入库） */
export function fetchBatchCreate(files, problemTags = '') {
  return request.post('/data/batch-create', { files, problem_tags: problemTags });
}

/** 删除数据分组：MySQL 记录 + PostgreSQL 标注 + MinIO 文件 */
export function deleteDataGroup(objectName, password) {
  return request.post('/data/delete', { object_name: objectName, password });
}

/** 更新指定文件夹的问题分类标签 */
export function updateProblemTags(objectName, problemTags) {
  return request.put('/data/problem-tags', { object_name: objectName, problem_tags: problemTags });
}
